var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1176 1.41406H7C4.23858 1.41406 2 3.65264 2 6.41406V29.4141C2 32.1755 4.23858 34.4141 7 34.4141H25C27.7614 34.4141 30 32.1755 30 29.4141V11.1518M20.1176 1.41406L30 11.1518M20.1176 1.41406V10.1518C20.1176 10.7041 20.5654 11.1518 21.1176 11.1518H30M8.58824 26.2993H22.3137M8.58824 18.1846H22.3137M8.58824 10.0698H14.0784",
    stroke: "#F6F7F8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.fc491172.svg";
export { ForwardRef as ReactComponent };